import React from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { useGetAccount } from '~/hooks/apis/offers/useGetAccount';

import { pluralizeToString } from '~/utils/stringUtils';

import FieldHistoryPanel from '../shared/fieldHistory/FieldHistoryPanel';
import { MOCK_ACCOUNT_HISTORY } from '../shared/fieldHistory/mockFieldHistory';

import AccountTabs from './AccountTabs';

export default function AccountHistoryPage() {
  const { id_account: accountId } = useParams<{ id_account: string }>();
  const { data: account } = useGetAccount(accountId);

  return (
    <>
      <Helmet>
        <title>Account History | {account?.name || accountId}</title>
      </Helmet>

      <AccountTabs accountId={accountId} activeTab="history" />
      <FieldHistoryPanel
        chipLabel={pluralizeToString('change', MOCK_ACCOUNT_HISTORY.length)}
        entries={MOCK_ACCOUNT_HISTORY}
        title="Account History"
      />
    </>
  );
}
